/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mobile_Report_Send_ErrorInputs */

const en_mobile_report_send_error = /** @type {(inputs: Mobile_Report_Send_ErrorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Error when sending report`)
};

const es_mobile_report_send_error = /** @type {(inputs: Mobile_Report_Send_ErrorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Error al enviar el reporte`)
};

/**
* | output |
* | --- |
* | "Error when sending report" |
*
* @param {Mobile_Report_Send_ErrorInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const mobile_report_send_error = /** @type {((inputs?: Mobile_Report_Send_ErrorInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mobile_Report_Send_ErrorInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_mobile_report_send_error(inputs)
	return en_mobile_report_send_error(inputs)
});